import { Component, Inject } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Config, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import * as markerjs2 from 'markerjs2';
import { take } from 'rxjs/operators';
import { CodePushService } from 'src/app/shared/services/code-push/code-push.service';
import { EnvironmentService } from 'src/app/shared/services/environment/environment.service';
import { environment } from 'src/environments/environment';

import { IPipelineRegistry } from './shared/pipeline/contracts/start/pipeline-registry';
import { PipelineRegistry } from './shared/pipeline/start/pipeline-registry';
import { StatusBarService } from './shared/services/statusbar.service';
import { TrackerService } from './shared/services/tracker.service';

declare var Capacitor;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private platform: Platform,
    private config: Config,
    private splashScreen: SplashScreen,
    private codePushService: CodePushService,
    private environmentService: EnvironmentService,
    private readonly tracker: TrackerService,
    private _statusBarService: StatusBarService,
    @Inject(PipelineRegistry) private _pipelineRegistry: IPipelineRegistry
  ) {
    this.initializeApp();
    markerjs2.Activator.addKey(environment.markerjs2Key);
  }

  async initializeApp() {
    this.initTranslate();
    await this.platform.ready();
    Capacitor = undefined;
    await this.codePushService.setChannel();
    await this.environmentService.init();
    await this._pipelineRegistry.start();

    const branch = this.environmentService.branch;
    // tslint:disable-next-line:max-line-length
    const release = `alberta-${this.platform.is('cordova') ? 'app' : 'web'}@${this.environmentService.version}-${
      this.environmentService.buildNumber
    }`;
    Sentry.init({
      dsn: environment.sentry.dsn,
      environment: this.environmentService.branch,
      release,
      ignoreErrors: [
        'Twilsock: request timeout',
        'Timeout of 60000ms exceeded calling update on ping',
        'Timeout of 60000ms exceeded calling create on authentication',
        'Timeout of 60000ms exceeded',
        'src/vendor/mobiscroll/js/mobiscroll.custom-4.0.0',
        'NotAuthenticated: Not authenticated',
        /Loading Chunk \d*/,
        // sentry
        'Error: disconnected Error: disconnected',
        'transition is invalid while previous transition is still in progress',
        'disconnected (status: 0, code: 0)',
        // tslint:disable-next-line:quotemark
        "Can't connect to twilsock",
      ],
    });

    if (!this.platform.is('cordova')) {
      return;
    }

    this._statusBarService.setColorFromHex('#ffffff');
    this.splashScreen.hide();
    this.tracker.setVersion(branch, release);

    this.codePushService.sync();
  }

  initTranslate() {
    this.translate.setDefaultLang('de');
    this.translate.use('de');

    this.translate
      .get(['BACK_BUTTON_TEXT'])
      .pipe(take(1))
      .subscribe(values => {
        if (this.platform.is('ios')) {
          this.config.set('backButtonText', values.BACK_BUTTON_TEXT);
        }
      });
  }
}
